<template>
  <div class="dados-infracao">
    <Card title="Dados da Infração">
      <lista-component :dados="dadosComputados" />
    </Card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card";
import ListaComponent from "./ListaComponent";

export default {
  name: "DadosInfracao",
  components: { ListaComponent, Card },
  props: {
    analise: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      headers: [
        { text: "Orgão Autuador", value: "AMC" },
        { text: "Descrição da Infração", value: "infracao.descricao" }
      ]
    };
  },
  computed: {
    dadosComputados() {
      return {
        "Orgão Autuador": "AMC",
        "Descrição da Infração": this.analise.infracao ? this.analise.infracao.descricao : "1",
        "Data Infração": this.$options.filters.data(this.analise.datetime_cometimento),
        "ID Equipamento": this.analise.cod_equipamento,
        "Certificado Aferição Inmetro": this.analise.certificado || "-",
        "Data Aferição": this.$options.filters.data(this.analise.data_afericao) || "-",
      };
    }
  }
};
</script>
